import { faHeart } from "@fortawesome/free-solid-svg-icons"
import Icon from "../Icon"
import Banner from '../../assets/images/hero.png'
import { Link } from "react-router-dom"
import { dateFormat } from "../../utils"


export default ({ data ={} }) => {
    return (
        <div className='bg-light border rounded-4 shadow-sm'>
            <div className='position-relative' style={{ height: "250px" }}>
                <Link to={`/tours-events/${ data._id }`} >
                    <img src={data.files?.at(0)?.Url || Banner} className='w-100 h-100 image-cover' style={{ borderRadius: "16px 16px 0 0" }} />
                </Link>
                <div className='position-absolute bg-white rounded-circle d-flex justify-content-center align-items-center' style={{ bottom: "10px", right: "10px", zIndex: 9, width: "40px", height: "40px" }}>
                    <Icon icon={faHeart} className="fs-5 text-danger" />
                </div>
            </div>
            <div className='p-3'>
                <ul className='d-flex p-0 mb-1'>
                    <li className='mx-3 text-primary fs-9'>{ dateFormat(data.start_from )}</li>
                    <li className='mx-4 text-primary fs-9'>{ data.departure_from }</li>
                </ul>
                <Link to={`/tours-events/${ data._id }`} className='my-2 text-saffron fs-4'>{ data.title }</Link>
                <p className='mb-0 fs-6' style={{ height: "70px", overflow:"hidden" }}>{ data.description }</p>
            </div>
        </div>
    )
}